// extracted by mini-css-extract-plugin
export default {"component":"BonusHeader__component--slots-DnGrs","title":"BonusHeader__title--slots-vAj5T","timer":"BonusHeader__timer--slots-ZXFfa"};